export default __webpack_public_path__ + "assets/ba858f672418e66782384955702e1f93.png";